// 📄 catalogoTablasService.ts
// Catálogo GLOBAL de Tablas SAP estándar de referencia (ej. transacción
// SE16N + tabla ARBCIG_MSG_ATTRS + campos), visible a TODOS los usuarios
// de la plataforma. Mismo patrón exacto que catalogoBadisService.ts/
// catalogoProgramasService.ts: CRUD completo solo desde el panel Admin,
// lectura abierta a cualquier consultor autenticado (ver firestore.rules,
// colección `catalogoTablas`). Proceso INDEPENDIENTE de las Tablas Z por
// proyecto (ver tablaZService.ts) — acá es referencia estándar mantenida
// por Admin, allá son registros propios de cada proyecto.
import {
  doc,
  collection,
  getDocs,
  setDoc,
  deleteDoc,
  serverTimestamp
} from "firebase/firestore";
import { db } from '../firebase';
import { SolucionBadi } from './catalogoBadisService.ts';
import { CampoTabla } from './tablaZService.ts';

export interface TablaEstandarData {
  nombreTecnico: string;
  transaccion: string;
  descripcion: string;
  solucion: SolucionBadi;
  campos: CampoTabla[];
}

export interface TablaEstandar extends TablaEstandarData {
  id: string;
  createdAt?: any;
  updatedAt?: any;
}

const CATALOGO_COLLECTION = "catalogoTablas";

export const getTablasEstandar = async (): Promise<TablaEstandar[]> => {
  const snap = await getDocs(collection(db, CATALOGO_COLLECTION));
  return snap.docs
    .map((d) => ({ id: d.id, ...(d.data() as Omit<TablaEstandar, 'id'>) }))
    .sort((a, b) => a.nombreTecnico.localeCompare(b.nombreTecnico));
};

export const saveTablaEstandar = async (tablaId: string, data: TablaEstandarData, esNueva: boolean): Promise<void> => {
  if (!data.nombreTecnico.trim()) throw new Error("El nombre técnico de la tabla es obligatorio.");

  const payload: Record<string, any> = {
    nombreTecnico: data.nombreTecnico.trim(),
    transaccion: data.transaccion.trim(),
    descripcion: data.descripcion.trim(),
    solucion: data.solucion,
    campos: data.campos.filter((c) => c.nombre.trim()).map((c) => ({ nombre: c.nombre.trim(), descripcion: c.descripcion.trim() })),
    updatedAt: serverTimestamp()
  };
  if (esNueva) payload.createdAt = serverTimestamp();

  await setDoc(doc(db, CATALOGO_COLLECTION, tablaId), payload, { merge: true });
};

export const deleteTablaEstandar = async (tablaId: string): Promise<void> => {
  await deleteDoc(doc(db, CATALOGO_COLLECTION, tablaId));
};
